import { useState } from "react";
import styles from "./FeatureSwitch.module.css";

type FeatureSwitchProp = {
  setScreenDisplay: (arg: string) => void;
};

function FeatureSwitch(props: FeatureSwitchProp): JSX.Element {
  const { setScreenDisplay } = props;

  const [btnState, setBtnState] = useState([
    "bg-saasPrimaryBlue text-white",
    "border border-[#DEDEDE] text-[#262626] font-semibold",
    "border border-[#DEDEDE] text-[#262626] font-semibold",
    "border border-[#DEDEDE] text-[#262626] font-semibold",
  ]);

  const getNewViewArea = () => {
    const element = document.getElementById(`scrollcontentArea`);
    // element?.scrollIntoView({ behavior: "smooth", block: "start" });

    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 270;
      // 80; // header height

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  const SwitchFocus = (index: number) => {
    setBtnState(
      btnState.map((btn, index2) => {
        console.log(btn);
        if (index === index2) {
          return "bg-saasPrimaryBlue text-white";
        }
        return "border border-[#DEDEDE] text-[#262626] font-semibold";
      })
    );
    getNewViewArea();
  };

  return (
    <div className="w-[288px] z-0 sticky left-0 top-[270px]  bg-white phone:w-full h-fit flex flex-col phone:overflow-y-hidden phone:scrollbar-hide phone:gap-x-4 phone:flex-row phone:overflow-x-auto px-4 phone:px-0 py-6 phone:py-2  gap-y-5 rounded-lg phone:border-none border border-[#DEDEDE]">
      <div
        className={`${styles.BtnPrimary} ${btnState[0]}`}
        onClick={() => {
          SwitchFocus(0);
          setScreenDisplay("userManagement");
        }}
        id={`knowledgeBtn1`}
        tabIndex={0}
        role="button"
        onKeyDown={() => {}}
      >
        User Manager
      </div>
      <div
        className={`${styles.BtnPrimary} ${btnState[1]}`}
        onClick={() => {
          SwitchFocus(1);
          setScreenDisplay("videoLibrary");
        }}
        id={`knowledgeBtn2`}
        tabIndex={0}
        role="button"
        onKeyDown={() => {}}
      >
        Video Library
      </div>
      <div
        className={`${styles.BtnPrimary} ${btnState[2]}`}
        onClick={() => {
          SwitchFocus(2);
          setScreenDisplay("courseManager");
        }}
        id={`knowledgeBtn3`}
        tabIndex={0}
        role="button"
        onKeyDown={() => {}}
      >
        Course Manager
      </div>
      <div
        className={`${styles.BtnPrimary} ${btnState[3]}`}
        onClick={() => {
          SwitchFocus(3);
          setScreenDisplay("eventManager");
        }}
        id={`knowledgeBtn4`}
        tabIndex={0}
        role="button"
        onKeyDown={() => {}}
      >
        Event Manager
      </div>
    </div>
  );
}

export default FeatureSwitch;
